import React, { useState } from 'react';
import Piechartitems from "../hqReport/Piechartitems";
import Piechartitems2 from "../hqReport/Piechartitems2";
import Piechartitems3 from "../hqReport/Piechartitems3";
import Billinvoice from "../hqReport/Billinvoice";
import Chart from './Chart';

function Piechart({ invoicesByMonth, monthlyPaidStatusCounts, monthlyPaidStatusAmounts }) {
  const { thisMonth, lastMonth, twoMonthsAgo } = invoicesByMonth || {};
  const paidAmounts = monthlyPaidStatusAmounts || {};

  return (
    <div className="reportmap">
      <div className="reportmap_1">
        {thisMonth > 0 && (<Chart label="This Month" amount={thisMonth} statusCounts={monthlyPaidStatusCounts.thisMonth} statusAmounts={paidAmounts.thisMonth} />)}
        {lastMonth > 0 && (<Chart label="Last Month" amount={lastMonth} statusCounts={monthlyPaidStatusCounts.lastMonth} statusAmounts={paidAmounts.lastMonth} />)}
        {twoMonthsAgo > 0 && (<Chart label="2 Months Ago" amount={twoMonthsAgo} statusCounts={monthlyPaidStatusCounts.twoMonthsAgo} statusAmounts={paidAmounts.twoMonthsAgo} />)}
        {(thisMonth > 0 || lastMonth > 0 || twoMonthsAgo > 0) && <Billinvoice />}
      </div>
    </div>
  );
}

export default Piechart;
